var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 0.5L34.9558 8.54429L43.0001 11.5L34.9558 14.4557L32.0001 22.5L29.0444 14.4557L21.0001 11.5L29.0444 8.54429L32.0001 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50006 2.5L8.24661 7.25345L13.0001 9L8.24661 10.7466L6.50006 15.5L4.75351 10.7466L6.10352e-05 9L4.75351 7.25345L6.50006 2.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 20.5L14.784 26.716L21.0001 29L14.784 31.284L12.5001 37.5L10.2161 31.284L4.00006 29L10.2161 26.716L12.5001 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingStar);
export default __webpack_public_path__ + "static/media/heading-star.4428f94af18196118d22c11069df9754.svg";
export { ForwardRef as ReactComponent };